export const GET_ROAD_ASSISTANT_SERVICES = "GET_ROAD_ASSISTANT_SERVICES";
export const GET_MEMBERSHIP_ID = "GET_MEMBERSHIP_ID";
export const SET_ACTIVE_CAR = "SET_ACTIVE_CAR";
export const SUBMIT_ROAD_ASSISTANT_REQUEST = "SUBMIT_ROAD_ASSISTANT_REQUEST";
